export const STATUS = {
	[true]: 'global.status.active',
	[false]: 'global.status.inActive',
};

export const VISIBILITY = {
	[true]: 'global.visibility.on',
	[false]: 'global.visibility.off',
};
